<template>
  <div class="empty">
    <div class="empty-img">
      <img v-if="showUrl" :src="require(`@/assets/images/${showUrl}`)" :alt="showUrl" />
    </div>
    <div class="empty-tip">
      <span>{{ $t("public.noData") }}</span>
    </div>
    <el-button
      v-show="isBtn"
      class="self-button-width"
      icon="el-icon-circle-plus-outline"
      type="primary"
      @click="addData"
    >
      {{ btnTxt }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "Empty",
  components: {},
  props: {
    srcType: {
      type: String,
      default: "default"
    },
    isBtn: {
      type: Boolean,
      default: false
    },
    nameArr: {
      type: Array,
      default: () => []
    },
    btnTxt: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showUrl: "empty.png",
      srcUrl: [{ type: "default", url: this.showUrl }]
    };
  },
  computed: {},
  watch: {
    srcType(val, oldVal) {
      this.srcUrl.forEach(s => {
        if (s.type === val) {
          this.showUrl = s.url;
        }
      });
    }
  },
  created() {},
  mounted() {},
  methods: {
    addData() {
      this.$emit("newData");
    }
  }
};
</script>

<style scoped lang="scss">
.empty {
  display: flex;
  width: 100%;
  // height: calc(100% - 115px);
  padding: 5% 0 0;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .empty-img {
    width: 140px;
    height: 140px;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }

  .empty-tip {
    line-height: 52px;
  }
}
</style>
